import PasswordCheckComponent from "./components/PasswordCheckComponent"
import {setPasswordCheckCalcs, setPasswordCheckFailureCalcs} from "./actions/index"
import {passwordCheck} from "./reducers/index"
import {passwordCheckService} from "./service/PasswordCheckService"

const PasswordCheck = {
    PasswordCheckComponent,
    passwordCheckService,
    actions: {
        setPasswordCheckCalcs,
        setPasswordCheckFailureCalcs
    },
    reducer: passwordCheck
};

export default PasswordCheck;